import { atom } from 'recoil'

export const IsHighlightingAtom = atom<boolean>({
  key: 'is-highlighting',
  default: false,
})
